<template>
    <div
        v-for="(message, index) in messages"
        :key="index"
        class="items-start animate-[msgIn_0.18s_ease]"
        :class="message.role === 'user' ? 'flex-row-reverse' : ''"
    >
        <div
            class="flex gap-x-3"
            :class="[message.role === 'user' ? 'justify-end' : 'max-w-[93%]']"
        >
            <div
                v-if="message.role !== 'user'"
                class="min-w-7.5"
            >
                <ChatAiLogoIcon />
            </div>

            <div
                v-html="formatText(message.content)"
                class="agent-msg-text text-xs text-gray-370 dark:text-white"
                :class="{ 'max-w-[93%] px-3 py-2.5 bg-purple-60 dark:bg-blue-775 rounded-2.5': message.role === 'user' }"
            ></div>
        </div>
    </div>

    <div
        v-if="isStreaming || streamingAnswer"
        class="animate-[msgIn_0.18s_ease]"
    >
        <div class="flex flex-col gap-1.5">
            <div class="flex gap-x-3 max-w-[93%]">
                <div class="min-w-7.5">
                    <ChatAiLogoIcon />
                </div>

                <div>
                    <div
                        v-html="streamingAnswer ? formatText(streamingAnswer) : ''"
                        class="agent-msg-text text-xs text-gray-370 dark:text-white"
                    ></div>

                    <span v-if="isStreaming && !streamingAnswer" class="pt-3 text-xs generating">
                        Generating
                    </span>

                    <span
                        v-if="isStreaming && streamingAnswer"
                        class="agent-cursor inline text-[12px] text-purple-450 dark:text-purple-300"
                    >▋</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import ChatAiLogoIcon from '@/components/ai/icons/ChatAiLogoIcon.vue'

defineProps({
    isStreaming: {
        type: Boolean,
        default: false,
    },
    streamingAnswer: {
        type: String,
        default: '',
    },
    messages: {
        type: Array,
        default: () => [],
    },
})

function formatText(text) {
    if (!text) {
        return ''
    }

    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\*\*(.+?)\*\*/g, '<strong class="text-orange-50 font-medium">$1</strong>')
        .replace(/\*(.+?)\*/g, '<em>$1</em>')
        .replace(/`(.+?)`/g, '<code>$1</code>')
        .replace(/\n/g, '<br>')
}
</script>
